/**
 * Shopify 3D Model Viewer
 * ========================
 * Drop this file into: assets/3d-model-viewer.js
 * Then add this ONE line anywhere in theme.liquid <head>:
 *
 *   {{ '3d-model-viewer.js' | asset_url | script_tag }}
 *
 * Requires:  <model-viewer> web component (loaded automatically below)
 * Browser:   Chrome 67+, Safari 15.4+, Firefox 98+, Edge 79+
 */

(function () {
  'use strict';

  /* ── 1. Inject <model-viewer> web component if not already loaded ──────── */
  if (!customElements.get('model-viewer')) {
    const script = document.createElement('script');
    script.type  = 'module';
    script.src   = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.4.0/model-viewer.min.js';
    document.head.appendChild(script);
  }

  /* ── 2. Inject CSS ─────────────────────────────────────────────────────── */
  const CSS = `
    /* ── Button ─────────────────────────────────── */
    
    .btn-3d-viewer:hover {
      border-color: #888;
      box-shadow: 0 2px 12px rgba(0,0,0,.1);
      transform: translateY(-1px);
    }
    .btn-3d-viewer:active { transform: translateY(0); }
    .btn-3d-viewer svg { flex-shrink: 0; }

    /* ── Modal overlay ───────────────────────────── */
    .viewer-modal {
      position: fixed;
      inset: 0;
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
    }
    .viewer-modal[hidden] { display: none !important; }

    .viewer-modal__backdrop {
      position: absolute;
      inset: 0;
      background: rgba(0,0,0,.55);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      animation: backdropIn .25s ease;
    }
    @keyframes backdropIn { from { opacity:0 } to { opacity:1 } }

    /* ── Modal panel ─────────────────────────────── */
    .viewer-modal__container {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      width: min(680px, 100%);
      max-height: min(780px, 95vh);
      background: #fff;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 24px 80px rgba(0,0,0,.3);
      animation: modalIn .3s cubic-bezier(.16,1,.3,1);
    }
    @keyframes modalIn {
      from { opacity:0; transform:scale(.92) translateY(16px) }
      to   { opacity:1; transform:scale(1)   translateY(0)    }
    }

    /* ── Header ──────────────────────────────────── */
    .viewer-modal__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 16px 14px 20px;
      border-bottom: 1px solid #ebebeb;
      flex-shrink: 0;
    }
    .viewer-modal__title {
      font-size: 14px;
      font-weight: 600;
      color: #1a1a1a;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 60%;
    }
    .viewer-modal__controls {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    /* ── Icon buttons ────────────────────────────── */
    .viewer-ctrl {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      padding: 6px 10px;
      font-family: inherit;
      font-size: 12px;
      font-weight: 600;
      color: #444;
      background: #f4f4f4;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      transition: background .15s, color .15s;
    }
    .viewer-ctrl:hover { background: #e8e8e8; color: #111; }
    .viewer-ctrl--close { background: transparent; }
    .viewer-ctrl--close:hover { background: #fee2e2; color: #dc2626; }

    /* ── Stage ───────────────────────────────────── */
    .viewer-modal__stage {
      position: relative;
      flex: 1;
      background: linear-gradient(135deg, #f8f8f8 0%, #efefef 100%);
      min-height: 400px;
    }

    /* model-viewer fills the stage */
    #shopify-model-viewer {
      width: 100%;
      height: 100%;
      min-height: 400px;
      --progress-bar-color: #2563eb;
      --progress-bar-height: 3px;
    }

    /* ── Loader ──────────────────────────────────── */
    .viewer-loader {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 12px;
      background: #f8f8f8;
      color: #888;
      font-size: 13px;
      z-index: 2;
      transition: opacity .3s;
    }
    .viewer-loader.hidden { opacity: 0; pointer-events: none; }
    .viewer-loader__spinner {
      width: 36px; height: 36px;
      border: 3px solid #e0e0e0;
      border-top-color: #2563eb;
      border-radius: 50%;
      animation: spin .8s linear infinite;
    }
    @keyframes spin { to { transform: rotate(360deg) } }

    /* ── Footer ──────────────────────────────────── */
    .viewer-modal__footer {
      padding: 10px 20px;
      border-top: 1px solid #ebebeb;
      flex-shrink: 0;
    }
    .viewer-hint {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 12px;
      color: #999;
    }

    /* ── Responsive ──────────────────────────────── */
    @media (max-width: 480px) {
      .viewer-modal__container { border-radius: 12px; }
      #shopify-model-viewer    { min-height: 300px; }
      .viewer-modal__stage     { min-height: 300px; }
    }
  `;

  const styleEl = document.createElement('style');
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  /* ── 3. Wire up interactivity ──────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', init);
  // Also try immediately in case DOM is already ready
  if (document.readyState !== 'loading') init();

  function init () {
    const openBtn    = document.getElementById('open-3d-viewer');
    const modal      = document.getElementById('viewer-modal');
    const backdrop   = modal && modal.querySelector('.viewer-modal__backdrop');
    const closeBtn   = document.getElementById('viewer-close-btn');
    const resetBtn   = document.getElementById('viewer-reset-btn');
    const arBtn      = document.getElementById('viewer-ar-btn');
    const arSlotBtn  = document.getElementById('ar-slot-btn');
    const mv         = document.getElementById('shopify-model-viewer');
    const loader     = document.getElementById('viewer-loader');
    const titleEl    = document.getElementById('viewer-modal-title');

    if (!openBtn || !modal || !mv) return;

    /* Open */
    openBtn.addEventListener('click', function () {
      const url   = this.dataset.modelUrl;
      const title = this.dataset.productTitle || '3D Model';

      titleEl.textContent = title;
      mv.src = url;
      loader.classList.remove('hidden');
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
    });

    /* Hide loader once model is ready */
    mv.addEventListener('load', function () {
      loader.classList.add('hidden');
      // Show AR button if device supports it
      if (mv.canActivateAR) arBtn.removeAttribute('hidden');
    });

    /* Close helpers */
    function closeModal () {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
      // Stop auto-rotate & clear src to free memory
      mv.removeAttribute('src');
      arBtn.setAttribute('hidden', '');
    }

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);

    /* Keyboard: Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });

    /* Reset camera */
    resetBtn.addEventListener('click', function () {
      mv.cameraOrbit  = 'auto auto auto';
      mv.cameraTarget = 'auto auto auto';
      mv.fieldOfView  = 'auto';
    });

    /* AR button — triggers the hidden slot button inside model-viewer */
    arBtn.addEventListener('click', function () {
      arSlotBtn.click();
    });
  }
})();
